import Swiper from "swiper/bundle";
import "swiper/css/bundle";
import { gsap } from "@gsap";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".flex-layout.accordion_cards-layout").forEach((layout) => {
        const items = [...layout.querySelectorAll(".accordion-item")];
        const swiperEl = layout.querySelector(".accordion-cards-swiper");
        if (!items.length) return;

        let swiper = null;
        let motion = false;

        gsap.matchMedia().add("(prefers-reduced-motion: no-preference)", () => {
            motion = true;
            return () => {
                motion = false;
            };
        });

        const revealText = (item) => {
            const lines = item.querySelectorAll(".accordion-panel .pk-text > *");
            if (!motion || !lines.length) return;

            gsap.fromTo(
                lines,
                { autoAlpha: 0, y: 12 },
                { autoAlpha: 1, y: 0, duration: 0.45, delay: 0.1, stagger: 0.06, ease: "power2.out", clearProps: "all" }
            );
        };

        const settleCard = () => {
            const image = swiper?.slides[swiper.activeIndex]?.querySelector("img");
            if (!motion || !image) return;

            gsap.fromTo(image, { scale: 1.08 }, { scale: 1, duration: 0.9, ease: "power3.out", clearProps: "transform" });
        };

        const setOpen = (index) => {
            items.forEach((item, i) => {
                const isOpen = i === index;
                const wasOpen = item.classList.contains("is-open");

                item.classList.toggle("is-open", isOpen);
                item.querySelector(".accordion-toggle")?.setAttribute("aria-expanded", String(isOpen));

                if (isOpen && !wasOpen) revealText(item);
            });
        };

        const count = Number(swiperEl?.dataset.items) || items.length;
        const itemIndex = () => swiper.realIndex % count;

        if (swiperEl && count > 1) {
            swiper = new Swiper(swiperEl, {
                effect: "cards",
                loop: true,
                grabCursor: true,
                speed: 500,
                cardsEffect: {
                    perSlideOffset: 6,
                    perSlideRotate: 3,
                    slideShadows: false,
                },
                a11y: { enabled: false },
            });

            gsap.matchMedia().add("(prefers-reduced-motion: reduce)", () => {
                swiper.params.speed = 0;
                return () => {
                    swiper.params.speed = 500;
                };
            });

            const markPassed = () => {
                swiper.slides.forEach((slide) => {
                    slide.classList.toggle("is-passed", slide.progress > 0.5 || slide.progress < -2.5);
                    slide.dataset.depth = String(Math.max(0, Math.round(-slide.progress)));
                });
            };

            markPassed();
            swiper.on("progress", markPassed);
            swiper.on("slideChange", () => {
                setOpen(itemIndex());
                settleCard();
            });
        }

        items.forEach((item, index) => {
            item.querySelector(".accordion-toggle")?.addEventListener("click", () => {
                if (item.classList.contains("is-open")) {
                    setOpen(-1);
                    return;
                }

                setOpen(index);

                if (swiper && itemIndex() !== index) {
                    swiper.slideToLoop(index);
                }
            });
        });
    });
});
